import { Period } from 'enums/shared/period';
import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import { homeApi } from './home';

export const surveysApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    sendGeneralSurvey: builder.mutation<
      SharesproApiResponse<void>,
      ApiGeneralSurveyRequest
    >({
      query: (data) => ({
        url: '/v3/common/npc',
        method: 'POST',
        sendToken: true,
        body: data,
      }),
      async onQueryStarted(data, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(
          homeApi.util.updateQueryData(
            'fetchHome',
            { period: Period.Month },
            (draft) => {
              draft.isShowGeneralSurvey = false;
            }
          )
        );
      },
    }),
  }),
});

export const { useSendGeneralSurveyMutation } = surveysApi;
